import * as React from "react";
import {ConditionLine} from "./ConditionLine";
import {ConditionBuilder, ConditionLineOptions, ConditionGroupOptions} from "./ConditionBuilder";

export class ConditionGroup extends React.Component<ConditionGroupProps, ConditionGroupState> {
    static defaultProps: Partial<ConditionGroupProps> = {};
    public ConditionLines:ConditionLine[];

    constructor(props: ConditionGroupProps) {
        super(props);
        this.state = {};
        this.ConditionLines=[];
    }

    public render() {
        this.ConditionLines=new Array(this.props.ConditionGroup.ConditionLines.length);
        return(
            <div className={'rnConditionGroup'} style={{marginBottom:10,tableLayout:'fixed',width:'100%'}}>
                <div>
                {
                    this.props.ConditionGroup.ConditionLines.map((line,index)=>

                            <ConditionLine ref={node=>{if(node!=null)this.ConditionLines[index]=node}} OnFieldChanged={()=>this.props.OnFieldChanged()} OnRemoveLine={x=>this.RemoveLine(x)} OnAddLine={x=>this.AddLineBellow(x)} key={line.Id} ConditionGroup={this} ConditionLineOptions={line}/>

                    )
                }
                </div>
            </div>
        )
    }

    private AddLineBellow(conditionLineOptions: ConditionLineOptions) {
        let index=this.props.ConditionGroup.ConditionLines.indexOf(conditionLineOptions);
        if(index<0)
            return;

        this.props.ConditionGroup.ConditionLines.splice(index+1,0,new ConditionLineOptions().Merge());

        this.props.OnFieldChanged();
        this.forceUpdate();
    }

    private RemoveLine(x: ConditionLineOptions) {
        let index=this.props.ConditionGroup.ConditionLines.indexOf(x);
        if(index<0)
            return;

        this.props.ConditionGroup.ConditionLines.splice(index,1);
        if(this.props.ConditionGroup.ConditionLines.length==0) {
            this.props.OnRemoveGroup(this.props.ConditionGroup);
            return;
        }
        this.props.OnFieldChanged();
        this.forceUpdate();
    }

    public get ConditionBuilder(){
        return this.props.ConditionBuilder;
    }

    public Validate(){
        for(let currentCondition of this.ConditionLines)
        {
            if(currentCondition.Validate()===false)
                return false;
        }
        return true;
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ConditionGroupProps {
    ConditionGroup:ConditionGroupOptions;
    ConditionBuilder:ConditionBuilder;
    OnRemoveGroup:(Group:ConditionGroupOptions)=>void;
    OnFieldChanged:()=>void;

}

interface ConditionGroupState {

}

//#endregion "My Region"